import { useCallback } from 'react';
import { useReactFlow, useStore } from '@xyflow/react';
import { IconCenter, IconZoomIn, IconZoomOut } from '@/icons';
import { StyledControlsButton, StyledControlsContainer } from './styles';

const FlowControls = () => {
  const { zoomIn, zoomOut, fitView } = useReactFlow();

  // Subscribe to zoom level from store
  const zoom = useStore((state) => state.transform[2]);

  const maxZoom = 2;
  const minZoom = 0.5;

  const isZoomedIn = zoom >= maxZoom;
  const isZoomedOut = zoom <= minZoom;

  const handleFocus = useCallback(() => {
    fitView({ padding: 0.4 });
  }, [fitView]);

  return (
    <StyledControlsContainer>
      <StyledControlsButton disabled={isZoomedIn} onClick={() => zoomIn()}>
        <IconZoomIn />
      </StyledControlsButton>
      <StyledControlsButton disabled={isZoomedOut} onClick={() => zoomOut()}>
        <IconZoomOut />
      </StyledControlsButton>
      <StyledControlsButton onClick={handleFocus}>
        <IconCenter />
      </StyledControlsButton>
    </StyledControlsContainer>
  );
};

export default FlowControls;
